import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { RestaurantComponent } from './pages/restaurant/restaurant.component';
import { CartComponent } from './pages/cart/cart.component';
import { AboutComponent } from './pages/about/about.component';
import { OffersComponent } from './pages/offers/offers.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ProductDeliveryAddressComponent } from './pages/product-delivery-address/product-delivery-address.component';
import { LoginComponent } from './pages/login/login.component';
import { ProductOrderSummaryComponentComponent } from './pages/product-order-summary-component/product-order-summary-component.component';
import { ProcessPaymentComponentComponent } from './pages/process-payment-component/process-payment-component.component';
import { OrderHistoryComponent } from './pages/order-history/order-history.component';
import { PaymentHistoryComponent } from './pages/payment-history/payment-history.component';
import { DeliveryPolicyComponent } from './pages/delivery-policy/delivery-policy.component';
import { PrivacyPolicyComponent } from './pages/privacypolicy/privacypolicy.component';
import { TermsConditionComponent } from './pages/terms-condition/terms-condition.component';
import { PaymentStatusComponent } from './pages/payment-status/payment-status.component';
import { PaymentSuccessComponent } from './pages/payment-success/payment-success.component';
import { PaymentFailComponent } from './pages/payment-fail/payment-fail.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { PaymentComponent } from './pages/payment/payment.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'restaurant/:id', component: RestaurantComponent },
  { path: 'cart', component: CartComponent },
  { path: 'about', component: AboutComponent },
  { path: 'offers', component: OffersComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'faq', component: ContactComponent },
  { path: 'delivery-policy', component: DeliveryPolicyComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms', component: TermsConditionComponent },
  { path: 'bulk-order', component: OffersComponent },
  { path: 'delivery-address', component: ProductDeliveryAddressComponent },
  { path: 'login', component: LoginComponent },
  { path: 'login/:id', component: LoginComponent },
  { path: 'order-summary', component: ProductOrderSummaryComponentComponent },
  { path: 'process-payment', component: ProcessPaymentComponentComponent },
  { path: "order-history", component: OrderHistoryComponent },
  { path: "payment-history", component: PaymentHistoryComponent },
  { path: "payment-status", component: PaymentStatusComponent },
  { path: "payment-success", component: PaymentSuccessComponent },
  { path: "payment-fail", component: PaymentFailComponent },
  { path: "profile", component: ProfileComponent },
  { path: "payment", component: PaymentComponent },
  { path: '**', redirectTo: '' }
];
